import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import Box from '@mui/material/Box';
import PlaceIcon from '@mui/icons-material/Place';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// CRA/webpack rewrites the image URLs but Leaflet's default icon still points
// at the un-hashed paths, so wire the bundled assets up by hand once.
const defaultIcon = L.icon({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

interface ActivityMapSlideProps {
    lat: number;
    lng: number;
    label?: string | null;
}

function ActivityMapSlide({ lat, lng, label }: ActivityMapSlideProps) {
    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100%', bgcolor: '#e7e2d3' }}>
            <MapContainer
                center={[lat, lng]}
                zoom={14}
                zoomControl={false}
                dragging={false}
                doubleClickZoom={false}
                scrollWheelZoom={false}
                touchZoom={false}
                keyboard={false}
                attributionControl={false}
                style={{ width: '100%', height: '100%' }}
            >
                <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={[lat, lng]} icon={defaultIcon} />
            </MapContainer>

            {label && (
                <Box
                    sx={{
                        position: 'absolute',
                        left: 10,
                        bottom: 10,
                        zIndex: 500,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.5,
                        maxWidth: 'calc(100% - 20px)',
                        px: 1,
                        py: '4px',
                        borderRadius: 999,
                        bgcolor: 'rgba(12, 18, 12, 0.62)',
                        backdropFilter: 'blur(4px)',
                        color: '#fff',
                        fontFamily: 'monospace',
                        fontSize: '0.66rem',
                        letterSpacing: '0.02em',
                    }}
                >
                    <PlaceIcon sx={{ fontSize: 12, flexShrink: 0 }} />
                    <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {label}
                    </Box>
                </Box>
            )}

            {/* OSM's tile usage policy asks for visible attribution. */}
            <Box
                component="a"
                href="https://www.openstreetmap.org/copyright"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
                sx={{
                    position: 'absolute',
                    right: 4,
                    bottom: 2,
                    zIndex: 500,
                    fontSize: '0.55rem',
                    color: 'rgba(0,0,0,0.55)',
                    bgcolor: 'rgba(255,255,255,0.7)',
                    px: '3px',
                    borderRadius: '3px',
                    textDecoration: 'none',
                }}
            >
                © OpenStreetMap
            </Box>
        </Box>
    );
}

export default ActivityMapSlide;
